// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"CheckboxInput_CheckboxInput__35JUi","BatchItemTag":"CheckboxInput_BatchItemTag__nnh1M"};